import React from 'react';
import PropTypes from 'prop-types';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Badge from '../SearchFilters/badge';
import reducer from './reducer';
import saga from './saga';
import { addOption, removeOption, showTag, hideTag } from './actions';
import { removeParam } from '../CatalogSearch/actions';

class Tags extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOnClick = (value, label, name, active) => {
    if (active) {
      if (name.length > 0) {
        this.props.removeParam(name);
      } else {
        this.props.removeOption(value);
        this.props.showTag(value);
      }
    } else {
      this.props.addOption(value, label);
      this.props.hideTag(value);
    }
  };

  render() {
    const { active, tags, params } = this.props;

    return (
      <div className="badge-filters" style={{ display: 'inline' }}>
        {tags.map((item, key) => {
          if (item === undefined) return null;

          const name = item.hasOwnProperty('name') ? item.name : '';
          let label = `${item.label}: `

          if (Array.isArray(item.value) && item.value.length > 1) {
            const itemValues = item.value.map(itemValue => {
              if (params[item.name] !== undefined) {
                const paramItem = params[item.name].find(el => el.value === itemValue);
                return paramItem.label;
              }

              return itemValue;
            });

            if (itemValues.length > 2) {
              label += itemValues.join(', ');
            } else {
              let [valueFrom, valueTo] = itemValues
              valueFrom = typeof valueFrom === 'number' ? valueFrom.toLocaleString('it') : valueFrom
              valueTo = typeof valueTo === 'number' ? valueTo.toLocaleString('it') : valueTo

              if (valueFrom === valueTo) {
                label += `${valueFrom}`
              } else {
                label += `${valueFrom}, ${valueTo}`;
              }
            }
          } else {
            const itemValue = Array.isArray(item.value) ? item.value[0] : item.value;

            if (params[item.name] !== undefined) {
              const paramItem = params[item.name].find(el => el.value === itemValue);
              label += paramItem.label;
            } else {
              label += itemValue;
            }
          }

          return (
            <Badge
              label={label}
              key={key}
              active={active}
              onClick={() =>
                this.handleOnClick(item.value, item.label, name, active)
              }
            />
          );
        })}
      </div>
    );
  }
}

Tags.defaultProps = {
  active: false,
  params: []
};

Tags.propTypes = {
  tags: PropTypes.array.isRequired,
  active: PropTypes.bool,
  params: PropTypes.any,
};

export function mapDispatchToProps(dispatch) {
  return {
    addOption: (value, label) => dispatch(addOption(value, label)),
    removeOption: value => dispatch(removeOption(value)),
    removeParam: name => dispatch(removeParam(name)),
    showTag: value => dispatch(showTag(value)),
    hideTag: value => dispatch(hideTag(value)),
  };
}

const withReducer = injectReducer({ key: 'filters', reducer });
const withSaga = injectSaga({ key: 'filters', saga });
const withConnect = connect(
  null,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(Tags);
